<template>
  <b-modal
    id="modal-select-folder"
    hide-footer
    size="lg"
    header-class="align-items-center pb-1"
  >
    <template #modal-header="{ close }">
      <h5 class="mb-0">Selecciona la carpeta de destino para el PDF</h5>
      <b-button
        variant="text"
        @click="closeModal"
        class="btn-close bg-transparent p-0 d-flex align-items-center justify-content-center"
        style="min-height: 24px"
      >
        <i
          class="ri-close-line hp-text-color-dark-0 lh-1"
          style="font-size: 24px"
        ></i>
      </b-button>
    </template>
    <section class="mb-8">
      <p
        class="d-flex justify-content-start align-items-center flex-wrap px-2"
        style="font-size: 12px"
      >
        <i
          class="ri-information-line hp-text-color-dark-0 text-warning mx-1"
          style="font-size: 24px"
        ></i>
        Haz doble click en la Carpeta donde se agregará el PDF y luego pulsa el
        botón Seleccionar Carpeta
      </p>
      <b-row align-content="center" align-h="center">
        <b-col cols="12" md="8" sm="12" align-self="center">
          <tree-view-folder
            @selectedNode="changeFolderSelected"
            ref="treeViewFolder"
            :items="foldersProjectPlatformFromProject"
          />
        </b-col>
      </b-row>
    </section>
    <section class="d-flex justify-content-end flex-wrap mt-32">
      <b-button variant="outline-info-3" @click="closeModal"> Cerrar </b-button>

      <b-button
        class="ml-2"
        :disabled="!folderSelected"
        variant="warning"
        @click="closeModalAndEmitFolderSelected"
      >
        Seleccionar Carpeta</b-button
      >
    </section>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TreeViewFolder from "@/layouts/components/common/TreeViewFolder.vue";

export default {
  components: { TreeViewFolder },
  data() {
    return {
      loading: false,
      folderSelected: null,
    };
  },
  methods: {
    ...mapActions({
      getFoldersProjectPlatformFromProject:
        "project/getFoldersProjectPlatformFromProject",
    }),
    changeFolderSelected(node) {
      this.folderSelected = node;
    },
    openModal() {
      this.$bvModal.show("modal-select-folder");
    },
    closeModal() {
      this.folderSelected = null;
      this.$bvModal.hide("modal-select-folder");
    },
    closeModalAndEmitFolderSelected() {
      this.$emit("folderSelected", this.folderSelected);
      this.closeModal();
    },
  },
  computed: {
    ...mapGetters({
      place: "place/place",
      foldersProjectPlatformFromProject:
        "project/foldersProjectPlatformFromProject",
    }),
  },
  watch: {
    place(newValue) {
      if (newValue) {
        this.getFoldersProjectPlatformFromProject({
          code: newValue.project.code,
        });
      }
    },
  },
};
</script>

<style></style>
